import React from "react";
import { Button } from "semantic-ui-react";
import { map } from "lodash";
import { Icon } from "../../../../assets";
import { socialData } from "../../../../Utils";
import "./Info.scss";

export function Info() {
  return (
    <div className="footer-info">
      <Icon.LogoWhite className="logo" />
      <p>
        Educa360 es una plataforma de educación digital que ofrece cursos en
        línea para estudiantes de habla hispana. Unete a nuestra comunidad y
        aprende de los mejores profesionales en el área de la tecnología.
      </p>
      <div className="button-group">
        {" "}
        {/* Agrupamos los botones aquí */}
        {map(socialData, (social) => (
          <Button
            key={social.type}
            as="a"
            href={social.link}
            color={social.type}
            target="_blank"
            icon={social.type}
          />
        ))}
      </div>
    </div>
  );
}
